import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TextareaInput from '@/common/components/base/textarea/textareaInput/TextInput';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { AddDescriptionModalType } from '@/modules/FileDetail/components/action/actionList/modals/AddDescriptionModal/AddDescriptionModal.types';
import { useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Flex } from 'styled-system/jsx';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <AddDescriptionModal closeModal={closeModal} />
  </MainModal>
);

const AddDescriptionModal = ({ closeModal }: AddDescriptionModalType) => {
  const { control, setValue, handleSubmit } = useFormContext();
  const { description } = useWatch({ control });
  const initValue = useRef(description);

  const onSubmit = () => {
    closeModal();
  };

  return (
    <>
      <TitleDescription>توضیحات</TitleDescription>
      <Typography my="24px" textStyle="b2">
        در صورت نیاز توضیحات مورد نظر خود را وارد کنید.
      </Typography>
      <TextareaInput
        placeholder="توضیحات تکمیلی را وارد کنید"
        name="description"
        label="توضیحات تکمیلی (اختیاری)"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex alignItems="center" gap="8px">
          <Button
            onClick={() => {
              setValue('description', initValue.current);
              closeModal();
            }}
            type="button"
            color="common"
            variant="outlined"
            fullWidth
          >
            بستن
          </Button>
          <Button fullWidth>ثبت</Button>
        </Flex>
      </form>
    </>
  );
};
